import React from 'react'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'

import i18nUiComponents from '../../../../locales/i18n'
import { TableFilter } from '../../../../types'
import Text from '../../../Text'

const useStyles = makeStyles(
  theme => ({
    root: {
      border: theme.constants.tableBorder,
      borderRadius: 2,
      padding: theme.spacing(2),
      backgroundColor: theme.colors.tableBackground,
      width: 'fit-content',
    },
  }),
  { name: 'NoResultsForFiltersLabel' },
)

export interface NoResultsForFiltersLabelProps {
  readonly filters?: Record<string, TableFilter>
  readonly onClearFilters: () => void
}

const NoResultsForFiltersLabel = ({
  filters: filtersProp,
  onClearFilters,
}: NoResultsForFiltersLabelProps) => {
  const filters = filtersProp || {}
  const classes = useStyles()
  const humanReadable = Object.keys(filters).reduce((acc, key) => {
    const filter = filters[key]
    if (!filter?.value || !filter?.humanReadable) {
      return acc
    }
    return [...acc, filter.humanReadable]
  }, [] as string[])

  return (
    <Grid container item alignItems="center" className={classes.root}>
      <Text>
        {`${i18nUiComponents.t<string>(
          'Common:NO_RESULTS_FOR',
        )} ‘${humanReadable.join(', ')}’.`}
      </Text>
      <Text link ml={1} onClick={onClearFilters}>
        {i18nUiComponents.t<string>('Common:CLEAR_FILTERS')}
      </Text>
    </Grid>
  )
}

export default NoResultsForFiltersLabel
